/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

.spectrum {
  font-family: adobe-clean, "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: var(--spectrum-alias-font-size-default, var(--spectrum-global-dimension-font-size-100));
}
.spectrum:lang(ar) {
    font-family: myriad-arabic, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum:lang(he) {
    font-family: myraid-hebrew, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum:lang(zh-Hans) {
    font-family: adobe-clean-han-japanese, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum:lang(zh) {
    font-family: adobe-clean-han-japanese, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum:lang(ko) {
    font-family: adobe-clean-han-japanese, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum:lang(ja) {
    font-family: adobe-clean-han-japanese, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }
.spectrum-Body1 {
            font-size: var(--spectrum-body-1-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-1-text-font-weight, 400);
  line-height: var(--spectrum-body-1-text-line-height, 1.5);
  font-style: var(--spectrum-body-1-text-font-style, normal);
  letter-spacing: var(--spectrum-body-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Body1 em {
                font-size: var(--spectrum-body-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body1 strong {
                font-size: var(--spectrum-body-1-strong-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body2,
.spectrum-Body--large {
            font-size: var(--spectrum-body-2-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-2-text-font-weight, 400);
  line-height: var(--spectrum-body-2-text-line-height, 1.5);
  font-style: var(--spectrum-body-2-text-font-style, normal);
  letter-spacing: var(--spectrum-body-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Body2 em,
.spectrum-Body--large em {
                font-size: var(--spectrum-body-2-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body2 strong,
.spectrum-Body--large strong {
                font-size: var(--spectrum-body-2-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body3 {
            font-size: var(--spectrum-body-3-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-3-text-font-weight, 400);
  line-height: var(--spectrum-body-3-text-line-height, 1.5);
  font-style: var(--spectrum-body-3-text-font-style, normal);
  letter-spacing: var(--spectrum-body-3-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Body3 em {
                font-size: var(--spectrum-body-3-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-3-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-3-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-3-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-3-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body3 strong {
                font-size: var(--spectrum-body-3-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-3-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-3-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-3-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body4,
.spectrum-Body--secondary {
            font-size: var(--spectrum-body-4-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-4-text-font-weight, 400);
  line-height: var(--spectrum-body-4-text-line-height, 1.5);
  font-style: var(--spectrum-body-4-text-font-style, normal);
  letter-spacing: var(--spectrum-body-4-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Body4 em,
.spectrum-Body--secondary em {
                font-size: var(--spectrum-body-4-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-4-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-4-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-4-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-4-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body4 strong,
.spectrum-Body--secondary strong {
                font-size: var(--spectrum-body-4-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-4-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-4-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-4-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body5,
.spectrum-Body--small {
            font-size: var(--spectrum-body-5-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-5-text-font-weight, 400);
  line-height: var(--spectrum-body-5-text-line-height, 1.5);
  font-style: var(--spectrum-body-5-text-font-style, normal);
  letter-spacing: var(--spectrum-body-5-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Body5 em,
.spectrum-Body--small em {
                font-size: var(--spectrum-body-5-emphasis-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-5-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-5-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-5-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-5-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Body5 strong,
.spectrum-Body--small strong {
                font-size: var(--spectrum-body-5-strong-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-5-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-5-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-5-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1 {
            font-size: var(--spectrum-heading-1-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-1-text-font-weight, 700);
  line-height: var(--spectrum-heading-1-text-line-height, 1.3);
  font-style: var(--spectrum-heading-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1 em {
                font-size: var(--spectrum-heading-1-emphasis-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-1-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1 strong {
                font-size: var(--spectrum-heading-1-strong-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2 {
            font-size: var(--spectrum-heading-2-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-2-text-font-weight, 700);
  line-height: var(--spectrum-heading-2-text-line-height, 1.3);
  font-style: var(--spectrum-heading-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2 em {
                font-size: var(--spectrum-heading-2-emphasis-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-2-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2 strong {
                font-size: var(--spectrum-heading-2-strong-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading3 {
            font-size: var(--spectrum-heading-3-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-3-text-font-weight, 700);
  line-height: var(--spectrum-heading-3-text-line-height, 1.3);
  font-style: var(--spectrum-heading-3-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-3-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading3 em {
                font-size: var(--spectrum-heading-3-emphasis-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-3-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-3-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-3-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-3-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading3 strong {
                font-size: var(--spectrum-heading-3-strong-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-3-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-3-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-3-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading4,
.spectrum-Heading--subtitle1 {
            font-size: var(--spectrum-heading-4-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-4-text-font-weight, 700);
  line-height: var(--spectrum-heading-4-text-line-height, 1.3);
  font-style: var(--spectrum-heading-4-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-4-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading4 em,
.spectrum-Heading--subtitle1 em {
                font-size: var(--spectrum-heading-4-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-4-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-4-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-4-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-4-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading4 strong,
.spectrum-Heading--subtitle1 strong {
                font-size: var(--spectrum-heading-4-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-4-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-4-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-4-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading5 {
            font-size: var(--spectrum-heading-5-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-5-text-font-weight, 700);
  line-height: var(--spectrum-heading-5-text-line-height, 1.3);
  font-style: var(--spectrum-heading-5-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-5-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading5 em {
                font-size: var(--spectrum-heading-5-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-5-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-5-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-5-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-5-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading5 strong {
                font-size: var(--spectrum-heading-5-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-5-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-5-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-5-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading6,
.spectrum-Heading--subtitle2 {
            font-size: var(--spectrum-heading-6-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-6-text-font-weight, 700);
  line-height: var(--spectrum-heading-6-text-line-height, 1.3);
  font-style: var(--spectrum-heading-6-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-6-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-6-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading6 em,
.spectrum-Heading--subtitle2 em {
                font-size: var(--spectrum-heading-6-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-6-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-6-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-6-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-6-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-6-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading6 strong,
.spectrum-Heading--subtitle2 strong {
                font-size: var(--spectrum-heading-6-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-6-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-6-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-6-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-6-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-6-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Subheading,
.spectrum-Heading--subtitle3 {
            font-size: var(--spectrum-subheading-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-text-font-weight, 700);
  line-height: var(--spectrum-subheading-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-subheading-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Subheading em,
.spectrum-Heading--subtitle3 em {
                font-size: var(--spectrum-subheading-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-subheading-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-subheading-emphasis-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-subheading-emphasis-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Subheading strong,
.spectrum-Heading--subtitle3 strong {
                font-size: var(--spectrum-subheading-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-strong-text-font-weight, 900);
  line-height: var(--spectrum-subheading-strong-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-strong-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-subheading-strong-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Detail {
            font-size: var(--spectrum-detail-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-text-font-weight, 400);
  line-height: var(--spectrum-detail-text-line-height, 1.5);
  font-style: var(--spectrum-detail-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-detail-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Detail em {
                font-size: var(--spectrum-detail-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-detail-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-detail-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-detail-emphasis-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-detail-emphasis-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Detail strong {
                font-size: var(--spectrum-detail-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-strong-text-font-weight, 700);
  line-height: var(--spectrum-detail-strong-text-line-height, 1.5);
  font-style: var(--spectrum-detail-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-strong-text-letter-spacing, 0.06em);
  text-transform: var(--spectrum-detail-strong-text-transform, uppercase);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--quiet {
            font-size: var(--spectrum-heading-quiet-1-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-1-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-1-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1--quiet em {
                font-size: var(--spectrum-heading-quiet-1-emphasis-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-1-emphasis-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-quiet-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-heading-quiet-1-strong-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-heading-quiet-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--quiet,
.spectrum-Heading--pageTitle {
            font-size: var(--spectrum-heading-quiet-2-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-2-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-2-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2--quiet em,
.spectrum-Heading--pageTitle em {
                font-size: var(--spectrum-heading-quiet-2-emphasis-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-2-emphasis-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-quiet-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--quiet strong,
.spectrum-Heading--pageTitle strong {
                font-size: var(--spectrum-heading-quiet-2-strong-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-heading-quiet-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-quiet-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--strong {
            font-size: var(--spectrum-heading-strong-1-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-strong-1-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-1-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1--strong em {
                font-size: var(--spectrum-heading-strong-1-emphasis-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-strong-1-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-strong-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--strong strong {
                font-size: var(--spectrum-heading-strong-1-strong-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-strong-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--strong {
            font-size: var(--spectrum-heading-strong-2-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-strong-2-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-2-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2--strong em {
                font-size: var(--spectrum-heading-strong-2-emphasis-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-strong-2-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-strong-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--strong strong {
                font-size: var(--spectrum-heading-strong-2-strong-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-strong-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-strong-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-heading-strong-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display {
            font-size: var(--spectrum-display-1-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-1-text-font-weight, 700);
  line-height: var(--spectrum-display-1-text-line-height, 1.3);
  font-style: var(--spectrum-display-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1--display em {
                font-size: var(--spectrum-display-1-emphasis-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-1-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-display-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display strong {
                font-size: var(--spectrum-display-1-strong-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display {
            font-size: var(--spectrum-display-2-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-2-text-font-weight, 700);
  line-height: var(--spectrum-display-2-text-line-height, 1.3);
  font-style: var(--spectrum-display-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2--display em {
                font-size: var(--spectrum-display-2-emphasis-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-2-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-display-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display strong {
                font-size: var(--spectrum-display-2-strong-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display.spectrum-Heading1--strong {
            font-size: var(--spectrum-display-strong-1-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-strong-1-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-1-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1--display.spectrum-Heading1--strong em {
                font-size: var(--spectrum-display-strong-1-emphasis-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-strong-1-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-strong-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display.spectrum-Heading1--strong strong {
                font-size: var(--spectrum-display-strong-1-strong-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-strong-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display.spectrum-Heading2--strong {
            font-size: var(--spectrum-display-strong-2-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-strong-2-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-2-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2--display.spectrum-Heading2--strong em {
                font-size: var(--spectrum-display-strong-2-emphasis-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-strong-2-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-strong-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display.spectrum-Heading2--strong strong {
                font-size: var(--spectrum-display-strong-2-strong-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-strong-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-strong-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-strong-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display.spectrum-Heading1--quiet {
            font-size: var(--spectrum-display-quiet-1-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-1-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-1-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading1--display.spectrum-Heading1--quiet em {
                font-size: var(--spectrum-display-quiet-1-emphasis-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-1-emphasis-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-quiet-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading1--display.spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-display-quiet-1-strong-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum-Heading--display {
            font-size: var(--spectrum-display-quiet-2-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-2-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-2-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Heading2--display.spectrum-Heading2--quiet em,
.spectrum-Heading--display em {
                font-size: var(--spectrum-display-quiet-2-emphasis-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-2-emphasis-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-quiet-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Heading2--display.spectrum-Heading2--quiet strong,
.spectrum-Heading--display strong {
                font-size: var(--spectrum-display-quiet-2-strong-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-display-quiet-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Typography .spectrum-Body1 {
            margin-top: var(--spectrum-body-1-margin-top, 0px);
            margin-bottom: var(--spectrum-body-1-margin-bottom, var(--spectrum-global-dimension-size-200));
          }
.spectrum-Typography .spectrum-Body2,
.spectrum-Typography .spectrum-Body--large {
            margin-top: var(--spectrum-body-2-margin-top, 0px);
            margin-bottom: var(--spectrum-body-2-margin-bottom, var(--spectrum-global-dimension-size-160));
          }
.spectrum-Typography .spectrum-Body3 {
            margin-top: var(--spectrum-body-3-margin-top, 0px);
            margin-bottom: var(--spectrum-body-3-margin-bottom, var(--spectrum-global-dimension-size-150));
          }
.spectrum-Typography .spectrum-Body4,
.spectrum-Typography .spectrum-Body--secondary {
            margin-top: var(--spectrum-body-4-margin-top, 0px);
            margin-bottom: var(--spectrum-body-4-margin-bottom, var(--spectrum-global-dimension-size-125));
          }
.spectrum-Typography .spectrum-Body5,
.spectrum-Typography .spectrum-Body--small {
            margin-top: var(--spectrum-body-5-margin-top, 0px);
            margin-bottom: var(--spectrum-body-5-margin-bottom, var(--spectrum-global-dimension-size-115));
          }
.spectrum-Typography .spectrum-Heading1 {
            margin-top: var(--spectrum-heading-1-margin-top, var(--spectrum-alias-heading1-margin-top));
            margin-bottom: var(--spectrum-heading-1-margin-bottom, var(--spectrum-global-dimension-size-115));
          }
.spectrum-Typography .spectrum-Heading2 {
            margin-top: var(--spectrum-heading-2-margin-top, var(--spectrum-alias-heading2-margin-top));
            margin-bottom: var(--spectrum-heading-2-margin-bottom, var(--spectrum-global-dimension-size-85));
          }
.spectrum-Typography .spectrum-Heading3 {
            margin-top: var(--spectrum-heading-3-margin-top, var(--spectrum-alias-heading3-margin-top));
            margin-bottom: var(--spectrum-heading-3-margin-bottom, var(--spectrum-global-dimension-size-75));
          }
.spectrum-Typography .spectrum-Heading4,
.spectrum-Typography .spectrum-Heading--subtitle1 {
            margin-top: var(--spectrum-heading-4-margin-top, var(--spectrum-global-dimension-font-size-200));
            margin-bottom: var(--spectrum-heading-4-margin-bottom, var(--spectrum-global-dimension-size-65));
          }
.spectrum-Typography .spectrum-Heading5 {
            margin-top: var(--spectrum-heading-5-margin-top, var(--spectrum-global-dimension-font-size-100));
            margin-bottom: var(--spectrum-heading-5-margin-bottom, var(--spectrum-global-dimension-size-50));
          }
.spectrum-Typography .spectrum-Heading6,
.spectrum-Typography .spectrum-Heading--subtitle2 {
            margin-top: var(--spectrum-heading-6-margin-top, var(--spectrum-global-dimension-size-150));
            margin-bottom: var(--spectrum-heading-6-margin-bottom, var(--spectrum-global-dimension-size-40));
          }
.spectrum-Typography .spectrum-Subheading,
.spectrum-Typography .spectrum-Heading--subtitle3 {
            margin-top: var(--spectrum-subheading-margin-top, var(--spectrum-global-dimension-size-150));
            margin-bottom: var(--spectrum-subheading-margin-bottom, var(--spectrum-global-dimension-size-40));
          }
.spectrum-Typography .spectrum-Detail {
            margin-top: var(--spectrum-detail-margin-top, 0px);
            margin-bottom: var(--spectrum-detail-margin-bottom, var(--spectrum-global-dimension-size-100));
          }
.spectrum-Typography .spectrum-Heading1--quiet {
            margin-top: var(--spectrum-heading-quiet-1-margin-top, var(--spectrum-alias-heading1-margin-top));
            margin-bottom: var(--spectrum-heading-quiet-1-margin-bottom, var(--spectrum-global-dimension-size-115));
          }
.spectrum-Typography .spectrum-Heading2--quiet,
.spectrum-Typography .spectrum-Heading--pageTitle {
            margin-top: var(--spectrum-heading-quiet-2-margin-top, var(--spectrum-alias-heading2-margin-top));
            margin-bottom: var(--spectrum-heading-quiet-2-margin-bottom, var(--spectrum-global-dimension-size-85));
          }
.spectrum-Typography .spectrum-Heading1--strong {
            margin-top: var(--spectrum-heading-strong-1-margin-top, var(--spectrum-alias-heading1-margin-top));
            margin-bottom: var(--spectrum-heading-strong-1-margin-bottom, var(--spectrum-global-dimension-size-115));
          }
.spectrum-Typography .spectrum-Heading2--strong {
            margin-top: var(--spectrum-heading-strong-2-margin-top, var(--spectrum-alias-heading2-margin-top));
            margin-bottom: var(--spectrum-heading-strong-2-margin-bottom, var(--spectrum-global-dimension-size-85));
          }
.spectrum-Typography .spectrum-Heading1--display {
            margin-top: var(--spectrum-display-1-margin-top, var(--spectrum-alias-heading-display1-margin-top));
            margin-bottom: var(--spectrum-display-1-margin-bottom, var(--spectrum-global-dimension-size-130));
          }
.spectrum-Typography .spectrum-Heading2--display {
            margin-top: var(--spectrum-display-2-margin-top, var(--spectrum-alias-heading-display2-margin-top));
            margin-bottom: var(--spectrum-display-2-margin-bottom, var(--spectrum-global-dimension-size-125));
          }
.spectrum-Typography .spectrum-Heading1--display.spectrum-Heading1--strong {
            margin-top: var(--spectrum-display-strong-1-margin-top, var(--spectrum-alias-heading-display1-margin-top));
            margin-bottom: var(--spectrum-display-strong-1-margin-bottom, var(--spectrum-global-dimension-size-130));
          }
.spectrum-Typography .spectrum-Heading2--display.spectrum-Heading2--strong {
            margin-top: var(--spectrum-display-strong-2-margin-top, var(--spectrum-alias-heading-display2-margin-top));
            margin-bottom: var(--spectrum-display-strong-2-margin-bottom, var(--spectrum-global-dimension-size-125));
          }
.spectrum-Typography .spectrum-Heading1--display.spectrum-Heading1--quiet {
            margin-top: var(--spectrum-display-quiet-1-margin-top, var(--spectrum-alias-heading-display1-margin-top));
            margin-bottom: var(--spectrum-display-quiet-1-margin-bottom, var(--spectrum-global-dimension-size-130));
          }
.spectrum-Typography .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum-Typography .spectrum-Heading--display {
            margin-top: var(--spectrum-display-quiet-2-margin-top, var(--spectrum-alias-heading-display2-margin-top));
            margin-bottom: var(--spectrum-display-quiet-2-margin-bottom, var(--spectrum-global-dimension-size-125));
          }
.spectrum-Article {
  font-family: var(--spectrum-body-article-1-text-font-family, adobe-clean-serif, 'Source Serif Pro', Georgia, serif);
}
.spectrum-Article .spectrum-Body1 {
            font-size: var(--spectrum-body-article-1-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-article-1-text-font-weight, 400);
  line-height: var(--spectrum-body-article-1-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-1-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-1-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Body1 em {
                font-size: var(--spectrum-body-article-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-article-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-article-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-article-1-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body1 strong {
                font-size: var(--spectrum-body-article-1-strong-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-article-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-article-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-1-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body2,
.spectrum-Article .spectrum-Body--large {
            font-size: var(--spectrum-body-article-2-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-article-2-text-font-weight, 400);
  line-height: var(--spectrum-body-article-2-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-2-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-2-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Body2 em,
.spectrum-Article .spectrum-Body--large em {
                font-size: var(--spectrum-body-article-2-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-article-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-article-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-article-2-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body2 strong,
.spectrum-Article .spectrum-Body--large strong {
                font-size: var(--spectrum-body-article-2-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-article-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-article-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-2-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body3 {
            font-size: var(--spectrum-body-article-3-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-article-3-text-font-weight, 400);
  line-height: var(--spectrum-body-article-3-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-3-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-3-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Body3 em {
                font-size: var(--spectrum-body-article-3-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-article-3-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-article-3-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-3-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-article-3-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body3 strong {
                font-size: var(--spectrum-body-article-3-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-article-3-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-article-3-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-3-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body4,
.spectrum-Article .spectrum-Body--secondary {
            font-size: var(--spectrum-body-article-4-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-article-4-text-font-weight, 400);
  line-height: var(--spectrum-body-article-4-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-4-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-4-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Body4 em,
.spectrum-Article .spectrum-Body--secondary em {
                font-size: var(--spectrum-body-article-4-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-article-4-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-article-4-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-4-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-article-4-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body4 strong,
.spectrum-Article .spectrum-Body--secondary strong {
                font-size: var(--spectrum-body-article-4-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-article-4-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-article-4-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-4-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body5,
.spectrum-Article .spectrum-Body--small {
            font-size: var(--spectrum-body-article-5-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-article-5-text-font-weight, 400);
  line-height: var(--spectrum-body-article-5-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-5-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-5-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Body5 em,
.spectrum-Article .spectrum-Body--small em {
                font-size: var(--spectrum-body-article-5-emphasis-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-article-5-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-article-5-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-5-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-article-5-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Body5 strong,
.spectrum-Article .spectrum-Body--small strong {
                font-size: var(--spectrum-body-article-5-strong-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-article-5-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-article-5-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-article-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-article-5-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-body-article-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1 {
            font-size: var(--spectrum-heading-article-1-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-article-1-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-1-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-1-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading1 em {
                font-size: var(--spectrum-heading-article-1-emphasis-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-article-1-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-1-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1 strong {
                font-size: var(--spectrum-heading-article-1-strong-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-article-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-1-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2 {
            font-size: var(--spectrum-heading-article-2-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-article-2-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-2-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-2-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading2 em {
                font-size: var(--spectrum-heading-article-2-emphasis-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-article-2-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-2-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2 strong {
                font-size: var(--spectrum-heading-article-2-strong-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-article-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-2-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading3 {
            font-size: var(--spectrum-heading-article-3-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-article-3-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-3-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-3-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-3-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading3 em {
                font-size: var(--spectrum-heading-article-3-emphasis-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-article-3-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-3-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-3-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-3-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading3 strong {
                font-size: var(--spectrum-heading-article-3-strong-text-size, var(--spectrum-alias-heading3-text-size));
  font-weight: var(--spectrum-heading-article-3-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-3-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-3-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading4,
.spectrum-Article .spectrum-Heading--subtitle1 {
            font-size: var(--spectrum-heading-article-4-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-article-4-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-4-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-4-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-4-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading4 em,
.spectrum-Article .spectrum-Heading--subtitle1 em {
                font-size: var(--spectrum-heading-article-4-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-article-4-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-4-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-4-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-4-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading4 strong,
.spectrum-Article .spectrum-Heading--subtitle1 strong {
                font-size: var(--spectrum-heading-article-4-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-article-4-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-4-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-4-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading5 {
            font-size: var(--spectrum-heading-article-5-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-article-5-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-5-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-5-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-5-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading5 em {
                font-size: var(--spectrum-heading-article-5-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-article-5-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-5-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-5-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-5-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading5 strong {
                font-size: var(--spectrum-heading-article-5-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-article-5-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-5-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-5-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading6,
.spectrum-Article .spectrum-Heading--subtitle2 {
            font-size: var(--spectrum-heading-article-6-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-article-6-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-6-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-6-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-6-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-6-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading6 em,
.spectrum-Article .spectrum-Heading--subtitle2 em {
                font-size: var(--spectrum-heading-article-6-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-article-6-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-heading-article-6-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-6-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-article-6-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-6-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading6 strong,
.spectrum-Article .spectrum-Heading--subtitle2 strong {
                font-size: var(--spectrum-heading-article-6-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-article-6-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-article-6-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-article-6-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-article-6-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-article-6-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Subheading,
.spectrum-Article .spectrum-Heading--subtitle3 {
            font-size: var(--spectrum-subheading-article-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-article-text-font-weight, 700);
  line-height: var(--spectrum-subheading-article-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-article-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-article-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-subheading-article-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Subheading em,
.spectrum-Article .spectrum-Heading--subtitle3 em {
                font-size: var(--spectrum-subheading-article-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-article-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-subheading-article-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-article-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-subheading-article-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-subheading-article-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Subheading strong,
.spectrum-Article .spectrum-Heading--subtitle3 strong {
                font-size: var(--spectrum-subheading-article-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-article-strong-text-font-weight, 900);
  line-height: var(--spectrum-subheading-article-strong-text-line-height, 1.3);
  font-style: var(--spectrum-subheading-article-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-article-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-subheading-article-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Detail {
            font-size: var(--spectrum-detail-article-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-article-text-font-weight, 400);
  line-height: var(--spectrum-detail-article-text-line-height, 1.5);
  font-style: var(--spectrum-detail-article-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-article-text-letter-spacing, 0);
  text-transform: var(--spectrum-detail-article-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Detail em {
                font-size: var(--spectrum-detail-article-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-article-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-detail-article-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-detail-article-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-detail-article-emphasis-text-letter-spacing, 0);
  text-transform: var(--spectrum-detail-article-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Detail strong {
                font-size: var(--spectrum-detail-article-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-article-strong-text-font-weight, 700);
  line-height: var(--spectrum-detail-article-strong-text-line-height, 1.5);
  font-style: var(--spectrum-detail-article-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-article-strong-text-letter-spacing, 0);
  text-transform: var(--spectrum-detail-article-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--quiet {
            font-size: var(--spectrum-heading-quiet-article-1-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-article-1-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-article-1-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-article-1-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading1--quiet em {
                font-size: var(--spectrum-heading-quiet-article-1-emphasis-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-article-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-article-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-quiet-article-1-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-heading-quiet-article-1-strong-text-size, var(--spectrum-alias-heading-display2-margin-top));
  font-weight: var(--spectrum-heading-quiet-article-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-quiet-article-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-article-1-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--quiet,
.spectrum-Article .spectrum-Heading--pageTitle {
            font-size: var(--spectrum-heading-quiet-article-2-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-article-2-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-article-2-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-article-2-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading2--quiet em,
.spectrum-Article .spectrum-Heading--pageTitle em {
                font-size: var(--spectrum-heading-quiet-article-2-emphasis-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-article-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-article-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-heading-quiet-article-2-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--quiet strong,
.spectrum-Article .spectrum-Heading--pageTitle strong {
                font-size: var(--spectrum-heading-quiet-article-2-strong-text-size, var(--spectrum-alias-heading2-text-size));
  font-weight: var(--spectrum-heading-quiet-article-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-quiet-article-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-heading-quiet-article-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-article-2-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-heading-quiet-article-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--display {
            font-size: var(--spectrum-display-article-1-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-article-1-text-font-weight, 700);
  line-height: var(--spectrum-display-article-1-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-article-1-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading1--display em {
                font-size: var(--spectrum-display-article-1-emphasis-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-article-1-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-display-article-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-article-1-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--display strong {
                font-size: var(--spectrum-display-article-1-strong-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-article-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-article-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-article-1-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--display {
            font-size: var(--spectrum-display-article-2-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-article-2-text-font-weight, 700);
  line-height: var(--spectrum-display-article-2-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-article-2-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading2--display em {
                font-size: var(--spectrum-display-article-2-emphasis-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-article-2-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-display-article-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-article-2-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--display strong {
                font-size: var(--spectrum-display-article-2-strong-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-article-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-article-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-article-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-article-2-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-article-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--display.spectrum-Heading1--quiet {
            font-size: var(--spectrum-display-quiet-article-1-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-article-1-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-article-1-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-article-1-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading1--display.spectrum-Heading1--quiet em {
                font-size: var(--spectrum-display-quiet-article-1-emphasis-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-article-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-article-1-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-quiet-article-1-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading1--display.spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-display-quiet-article-1-strong-text-size, var(--spectrum-alias-heading-display1-text-size));
  font-weight: var(--spectrum-display-quiet-article-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-article-1-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-article-1-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum-Article .spectrum-Heading--display {
            font-size: var(--spectrum-display-quiet-article-2-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-article-2-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-article-2-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-article-2-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum-Article .spectrum-Heading2--display.spectrum-Heading2--quiet em,
.spectrum-Article .spectrum-Heading--display em {
                font-size: var(--spectrum-display-quiet-article-2-emphasis-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-article-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-article-2-emphasis-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-display-quiet-article-2-emphasis-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Article .spectrum-Heading2--display.spectrum-Heading2--quiet strong,
.spectrum-Article .spectrum-Heading--display strong {
                font-size: var(--spectrum-display-quiet-article-2-strong-text-size, var(--spectrum-alias-heading-display1-margin-top));
  font-weight: var(--spectrum-display-quiet-article-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-article-2-strong-text-line-height, 1.3);
  font-style: var(--spectrum-display-quiet-article-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-article-2-strong-text-letter-spacing, 0.0125em);
  text-transform: var(--spectrum-display-quiet-article-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body1, .spectrum:lang(ko) .spectrum-Body1, .spectrum:lang(zh) .spectrum-Body1 {
            font-size: var(--spectrum-body-han-1-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-han-1-text-font-weight, 400);
  line-height: var(--spectrum-body-han-1-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Body1 em, .spectrum:lang(ko) .spectrum-Body1 em, .spectrum:lang(zh) .spectrum-Body1 em {
                font-size: var(--spectrum-body-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-han-1-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-body-han-1-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body1 strong, .spectrum:lang(ko) .spectrum-Body1 strong, .spectrum:lang(zh) .spectrum-Body1 strong {
                font-size: var(--spectrum-body-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-han-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-han-1-strong-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body2,
.spectrum:lang(ko) .spectrum-Body2,
.spectrum:lang(zh) .spectrum-Body2,
.spectrum:lang(ja) .spectrum-Body--large,
.spectrum:lang(ko) .spectrum-Body--large,
.spectrum:lang(zh) .spectrum-Body--large {
            font-size: var(--spectrum-body-han-2-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-han-2-text-font-weight, 400);
  line-height: var(--spectrum-body-han-2-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Body2 em,
.spectrum:lang(ko) .spectrum-Body2 em,
.spectrum:lang(zh) .spectrum-Body2 em,
.spectrum:lang(ja) .spectrum-Body--large em,
.spectrum:lang(ko) .spectrum-Body--large em,
.spectrum:lang(zh) .spectrum-Body--large em {
                font-size: var(--spectrum-body-han-2-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-han-2-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-body-han-2-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body2 strong,
.spectrum:lang(ko) .spectrum-Body2 strong,
.spectrum:lang(zh) .spectrum-Body2 strong,
.spectrum:lang(ja) .spectrum-Body--large strong,
.spectrum:lang(ko) .spectrum-Body--large strong,
.spectrum:lang(zh) .spectrum-Body--large strong {
                font-size: var(--spectrum-body-han-2-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-han-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-han-2-strong-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body3, .spectrum:lang(ko) .spectrum-Body3, .spectrum:lang(zh) .spectrum-Body3 {
            font-size: var(--spectrum-body-han-3-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-han-3-text-font-weight, 400);
  line-height: var(--spectrum-body-han-3-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-3-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-3-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Body3 em, .spectrum:lang(ko) .spectrum-Body3 em, .spectrum:lang(zh) .spectrum-Body3 em {
                font-size: var(--spectrum-body-han-3-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-han-3-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-body-han-3-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-3-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-3-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body3 strong, .spectrum:lang(ko) .spectrum-Body3 strong, .spectrum:lang(zh) .spectrum-Body3 strong {
                font-size: var(--spectrum-body-han-3-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-han-3-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-han-3-strong-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-3-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body4,
.spectrum:lang(ko) .spectrum-Body4,
.spectrum:lang(zh) .spectrum-Body4,
.spectrum:lang(ja) .spectrum-Body--secondary,
.spectrum:lang(ko) .spectrum-Body--secondary,
.spectrum:lang(zh) .spectrum-Body--secondary {
            font-size: var(--spectrum-body-han-4-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-han-4-text-font-weight, 400);
  line-height: var(--spectrum-body-han-4-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-4-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-4-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Body4 em,
.spectrum:lang(ko) .spectrum-Body4 em,
.spectrum:lang(zh) .spectrum-Body4 em,
.spectrum:lang(ja) .spectrum-Body--secondary em,
.spectrum:lang(ko) .spectrum-Body--secondary em,
.spectrum:lang(zh) .spectrum-Body--secondary em {
                font-size: var(--spectrum-body-han-4-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-han-4-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-body-han-4-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-4-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-4-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body4 strong,
.spectrum:lang(ko) .spectrum-Body4 strong,
.spectrum:lang(zh) .spectrum-Body4 strong,
.spectrum:lang(ja) .spectrum-Body--secondary strong,
.spectrum:lang(ko) .spectrum-Body--secondary strong,
.spectrum:lang(zh) .spectrum-Body--secondary strong {
                font-size: var(--spectrum-body-han-4-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-han-4-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-han-4-strong-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-4-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body5,
.spectrum:lang(ko) .spectrum-Body5,
.spectrum:lang(zh) .spectrum-Body5,
.spectrum:lang(ja) .spectrum-Body--small,
.spectrum:lang(ko) .spectrum-Body--small,
.spectrum:lang(zh) .spectrum-Body--small {
            font-size: var(--spectrum-body-han-5-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-han-5-text-font-weight, 400);
  line-height: var(--spectrum-body-han-5-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-5-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-5-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Body5 em,
.spectrum:lang(ko) .spectrum-Body5 em,
.spectrum:lang(zh) .spectrum-Body5 em,
.spectrum:lang(ja) .spectrum-Body--small em,
.spectrum:lang(ko) .spectrum-Body--small em,
.spectrum:lang(zh) .spectrum-Body--small em {
                font-size: var(--spectrum-body-han-5-emphasis-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-han-5-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-body-han-5-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-5-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-5-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Body5 strong,
.spectrum:lang(ko) .spectrum-Body5 strong,
.spectrum:lang(zh) .spectrum-Body5 strong,
.spectrum:lang(ja) .spectrum-Body--small strong,
.spectrum:lang(ko) .spectrum-Body--small strong,
.spectrum:lang(zh) .spectrum-Body--small strong {
                font-size: var(--spectrum-body-han-5-strong-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-han-5-strong-text-font-weight, 900);
  line-height: var(--spectrum-body-han-5-strong-text-line-height, 1.7);
  font-style: var(--spectrum-body-han-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-han-5-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-body-han-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1, .spectrum:lang(ko) .spectrum-Heading1, .spectrum:lang(zh) .spectrum-Heading1 {
            font-size: var(--spectrum-heading-han-1-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-han-1-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1 em, .spectrum:lang(ko) .spectrum-Heading1 em, .spectrum:lang(zh) .spectrum-Heading1 em {
                font-size: var(--spectrum-heading-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-han-1-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1 strong, .spectrum:lang(ko) .spectrum-Heading1 strong, .spectrum:lang(zh) .spectrum-Heading1 strong {
                font-size: var(--spectrum-heading-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-han-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2, .spectrum:lang(ko) .spectrum-Heading2, .spectrum:lang(zh) .spectrum-Heading2 {
            font-size: var(--spectrum-heading-han-2-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-han-2-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2 em, .spectrum:lang(ko) .spectrum-Heading2 em, .spectrum:lang(zh) .spectrum-Heading2 em {
                font-size: var(--spectrum-heading-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-han-2-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2 strong, .spectrum:lang(ko) .spectrum-Heading2 strong, .spectrum:lang(zh) .spectrum-Heading2 strong {
                font-size: var(--spectrum-heading-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-han-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading3, .spectrum:lang(ko) .spectrum-Heading3, .spectrum:lang(zh) .spectrum-Heading3 {
            font-size: var(--spectrum-heading-han-3-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-heading-han-3-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-3-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-3-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-3-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-3-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading3 em, .spectrum:lang(ko) .spectrum-Heading3 em, .spectrum:lang(zh) .spectrum-Heading3 em {
                font-size: var(--spectrum-heading-han-3-emphasis-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-heading-han-3-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-3-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-3-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-3-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-3-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading3 strong, .spectrum:lang(ko) .spectrum-Heading3 strong, .spectrum:lang(zh) .spectrum-Heading3 strong {
                font-size: var(--spectrum-heading-han-3-strong-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-heading-han-3-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-3-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-3-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-3-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading4,
.spectrum:lang(ko) .spectrum-Heading4,
.spectrum:lang(zh) .spectrum-Heading4,
.spectrum:lang(ja) .spectrum-Heading--subtitle1,
.spectrum:lang(ko) .spectrum-Heading--subtitle1,
.spectrum:lang(zh) .spectrum-Heading--subtitle1 {
            font-size: var(--spectrum-heading-han-4-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-han-4-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-4-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-4-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-4-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-4-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading4 em,
.spectrum:lang(ko) .spectrum-Heading4 em,
.spectrum:lang(zh) .spectrum-Heading4 em,
.spectrum:lang(ja) .spectrum-Heading--subtitle1 em,
.spectrum:lang(ko) .spectrum-Heading--subtitle1 em,
.spectrum:lang(zh) .spectrum-Heading--subtitle1 em {
                font-size: var(--spectrum-heading-han-4-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-han-4-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-4-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-4-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-4-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-4-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading4 strong,
.spectrum:lang(ko) .spectrum-Heading4 strong,
.spectrum:lang(zh) .spectrum-Heading4 strong,
.spectrum:lang(ja) .spectrum-Heading--subtitle1 strong,
.spectrum:lang(ko) .spectrum-Heading--subtitle1 strong,
.spectrum:lang(zh) .spectrum-Heading--subtitle1 strong {
                font-size: var(--spectrum-heading-han-4-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-heading-han-4-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-4-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-4-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-4-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading5, .spectrum:lang(ko) .spectrum-Heading5, .spectrum:lang(zh) .spectrum-Heading5 {
            font-size: var(--spectrum-heading-han-5-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-han-5-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-5-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-5-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-5-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-5-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading5 em, .spectrum:lang(ko) .spectrum-Heading5 em, .spectrum:lang(zh) .spectrum-Heading5 em {
                font-size: var(--spectrum-heading-han-5-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-han-5-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-5-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-5-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-5-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-5-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading5 strong, .spectrum:lang(ko) .spectrum-Heading5 strong, .spectrum:lang(zh) .spectrum-Heading5 strong {
                font-size: var(--spectrum-heading-han-5-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-heading-han-5-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-5-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-5-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-5-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading6,
.spectrum:lang(ko) .spectrum-Heading6,
.spectrum:lang(zh) .spectrum-Heading6,
.spectrum:lang(ja) .spectrum-Heading--subtitle2,
.spectrum:lang(ko) .spectrum-Heading--subtitle2,
.spectrum:lang(zh) .spectrum-Heading--subtitle2 {
            font-size: var(--spectrum-heading-han-6-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-han-6-text-font-weight, 700);
  line-height: var(--spectrum-heading-han-6-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-6-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-6-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-6-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading6 em,
.spectrum:lang(ko) .spectrum-Heading6 em,
.spectrum:lang(zh) .spectrum-Heading6 em,
.spectrum:lang(ja) .spectrum-Heading--subtitle2 em,
.spectrum:lang(ko) .spectrum-Heading--subtitle2 em,
.spectrum:lang(zh) .spectrum-Heading--subtitle2 em {
                font-size: var(--spectrum-heading-han-6-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-han-6-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-heading-han-6-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-6-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-6-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-6-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading6 strong,
.spectrum:lang(ko) .spectrum-Heading6 strong,
.spectrum:lang(zh) .spectrum-Heading6 strong,
.spectrum:lang(ja) .spectrum-Heading--subtitle2 strong,
.spectrum:lang(ko) .spectrum-Heading--subtitle2 strong,
.spectrum:lang(zh) .spectrum-Heading--subtitle2 strong {
                font-size: var(--spectrum-heading-han-6-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-heading-han-6-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-han-6-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-han-6-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-han-6-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-han-6-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Subheading,
.spectrum:lang(ko) .spectrum-Subheading,
.spectrum:lang(zh) .spectrum-Subheading,
.spectrum:lang(ja) .spectrum-Heading--subtitle3,
.spectrum:lang(ko) .spectrum-Heading--subtitle3,
.spectrum:lang(zh) .spectrum-Heading--subtitle3 {
            font-size: var(--spectrum-subheading-han-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-han-text-font-weight, 700);
  line-height: var(--spectrum-subheading-han-text-line-height, 1.5);
  font-style: var(--spectrum-subheading-han-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-han-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-subheading-han-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Subheading em,
.spectrum:lang(ko) .spectrum-Subheading em,
.spectrum:lang(zh) .spectrum-Subheading em,
.spectrum:lang(ja) .spectrum-Heading--subtitle3 em,
.spectrum:lang(ko) .spectrum-Heading--subtitle3 em,
.spectrum:lang(zh) .spectrum-Heading--subtitle3 em {
                font-size: var(--spectrum-subheading-han-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-han-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-subheading-han-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-subheading-han-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-han-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-subheading-han-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Subheading strong,
.spectrum:lang(ko) .spectrum-Subheading strong,
.spectrum:lang(zh) .spectrum-Subheading strong,
.spectrum:lang(ja) .spectrum-Heading--subtitle3 strong,
.spectrum:lang(ko) .spectrum-Heading--subtitle3 strong,
.spectrum:lang(zh) .spectrum-Heading--subtitle3 strong {
                font-size: var(--spectrum-subheading-han-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-subheading-han-strong-text-font-weight, 900);
  line-height: var(--spectrum-subheading-han-strong-text-line-height, 1.5);
  font-style: var(--spectrum-subheading-han-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-subheading-han-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-subheading-han-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Detail, .spectrum:lang(ko) .spectrum-Detail, .spectrum:lang(zh) .spectrum-Detail {
            font-size: var(--spectrum-detail-han-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-han-text-font-weight, 400);
  line-height: var(--spectrum-detail-han-text-line-height, 1.7);
  font-style: var(--spectrum-detail-han-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-han-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-detail-han-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Detail em, .spectrum:lang(ko) .spectrum-Detail em, .spectrum:lang(zh) .spectrum-Detail em {
                font-size: var(--spectrum-detail-han-emphasis-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-han-emphasis-text-font-weight, 700);
  line-height: var(--spectrum-detail-han-emphasis-text-line-height, 1.7);
  font-style: var(--spectrum-detail-han-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-han-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-detail-han-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Detail strong, .spectrum:lang(ko) .spectrum-Detail strong, .spectrum:lang(zh) .spectrum-Detail strong {
                font-size: var(--spectrum-detail-han-strong-text-size, var(--spectrum-global-dimension-font-size-50));
  font-weight: var(--spectrum-detail-han-strong-text-font-weight, 900);
  line-height: var(--spectrum-detail-han-strong-text-line-height, 1.7);
  font-style: var(--spectrum-detail-han-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-detail-han-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-detail-han-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--quiet, .spectrum:lang(ko) .spectrum-Heading1--quiet, .spectrum:lang(zh) .spectrum-Heading1--quiet {
            font-size: var(--spectrum-heading-quiet-han-1-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-quiet-han-1-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1--quiet em, .spectrum:lang(ko) .spectrum-Heading1--quiet em, .spectrum:lang(zh) .spectrum-Heading1--quiet em {
                font-size: var(--spectrum-heading-quiet-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-quiet-han-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--quiet strong, .spectrum:lang(ko) .spectrum-Heading1--quiet strong, .spectrum:lang(zh) .spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-heading-quiet-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-quiet-han-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-heading-quiet-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--quiet,
.spectrum:lang(ko) .spectrum-Heading2--quiet,
.spectrum:lang(zh) .spectrum-Heading2--quiet,
.spectrum:lang(ja) .spectrum-Heading--pageTitle,
.spectrum:lang(ko) .spectrum-Heading--pageTitle,
.spectrum:lang(zh) .spectrum-Heading--pageTitle {
            font-size: var(--spectrum-heading-quiet-han-2-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-quiet-han-2-text-font-weight, 300);
  line-height: var(--spectrum-heading-quiet-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2--quiet em,
.spectrum:lang(ko) .spectrum-Heading2--quiet em,
.spectrum:lang(zh) .spectrum-Heading2--quiet em,
.spectrum:lang(ja) .spectrum-Heading--pageTitle em,
.spectrum:lang(ko) .spectrum-Heading--pageTitle em,
.spectrum:lang(zh) .spectrum-Heading--pageTitle em {
                font-size: var(--spectrum-heading-quiet-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-quiet-han-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-heading-quiet-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--quiet strong,
.spectrum:lang(ko) .spectrum-Heading2--quiet strong,
.spectrum:lang(zh) .spectrum-Heading2--quiet strong,
.spectrum:lang(ja) .spectrum-Heading--pageTitle strong,
.spectrum:lang(ko) .spectrum-Heading--pageTitle strong,
.spectrum:lang(zh) .spectrum-Heading--pageTitle strong {
                font-size: var(--spectrum-heading-quiet-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-quiet-han-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-heading-quiet-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-quiet-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-quiet-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-quiet-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--strong, .spectrum:lang(ko) .spectrum-Heading1--strong, .spectrum:lang(zh) .spectrum-Heading1--strong {
            font-size: var(--spectrum-heading-strong-han-1-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-strong-han-1-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1--strong em, .spectrum:lang(ko) .spectrum-Heading1--strong em, .spectrum:lang(zh) .spectrum-Heading1--strong em {
                font-size: var(--spectrum-heading-strong-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-strong-han-1-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--strong strong, .spectrum:lang(ko) .spectrum-Heading1--strong strong, .spectrum:lang(zh) .spectrum-Heading1--strong strong {
                font-size: var(--spectrum-heading-strong-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-800));
  font-weight: var(--spectrum-heading-strong-han-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--strong, .spectrum:lang(ko) .spectrum-Heading2--strong, .spectrum:lang(zh) .spectrum-Heading2--strong {
            font-size: var(--spectrum-heading-strong-han-2-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-strong-han-2-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2--strong em, .spectrum:lang(ko) .spectrum-Heading2--strong em, .spectrum:lang(zh) .spectrum-Heading2--strong em {
                font-size: var(--spectrum-heading-strong-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-strong-han-2-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--strong strong, .spectrum:lang(ko) .spectrum-Heading2--strong strong, .spectrum:lang(zh) .spectrum-Heading2--strong strong {
                font-size: var(--spectrum-heading-strong-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-600));
  font-weight: var(--spectrum-heading-strong-han-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-heading-strong-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-heading-strong-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-heading-strong-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-heading-strong-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display, .spectrum:lang(ko) .spectrum-Heading1--display, .spectrum:lang(zh) .spectrum-Heading1--display {
            font-size: var(--spectrum-display-han-1-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-han-1-text-font-weight, 700);
  line-height: var(--spectrum-display-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1--display em, .spectrum:lang(ko) .spectrum-Heading1--display em, .spectrum:lang(zh) .spectrum-Heading1--display em {
                font-size: var(--spectrum-display-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-han-1-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-display-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display strong, .spectrum:lang(ko) .spectrum-Heading1--display strong, .spectrum:lang(zh) .spectrum-Heading1--display strong {
                font-size: var(--spectrum-display-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-han-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display, .spectrum:lang(ko) .spectrum-Heading2--display, .spectrum:lang(zh) .spectrum-Heading2--display {
            font-size: var(--spectrum-display-han-2-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-han-2-text-font-weight, 700);
  line-height: var(--spectrum-display-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2--display em, .spectrum:lang(ko) .spectrum-Heading2--display em, .spectrum:lang(zh) .spectrum-Heading2--display em {
                font-size: var(--spectrum-display-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-han-2-emphasis-text-font-weight, 800);
  line-height: var(--spectrum-display-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display strong, .spectrum:lang(ko) .spectrum-Heading2--display strong, .spectrum:lang(zh) .spectrum-Heading2--display strong {
                font-size: var(--spectrum-display-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-han-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--strong, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--strong, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--strong {
            font-size: var(--spectrum-display-strong-han-1-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-strong-han-1-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--strong em, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--strong em, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--strong em {
                font-size: var(--spectrum-display-strong-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-strong-han-1-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--strong strong, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--strong strong, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--strong strong {
                font-size: var(--spectrum-display-strong-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-strong-han-1-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--strong, .spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--strong, .spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--strong {
            font-size: var(--spectrum-display-strong-han-2-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-strong-han-2-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--strong em, .spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--strong em, .spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--strong em {
                font-size: var(--spectrum-display-strong-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-strong-han-2-emphasis-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--strong strong, .spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--strong strong, .spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--strong strong {
                font-size: var(--spectrum-display-strong-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-strong-han-2-strong-text-font-weight, 900);
  line-height: var(--spectrum-display-strong-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-strong-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-strong-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-strong-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--quiet, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--quiet, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--quiet {
            font-size: var(--spectrum-display-quiet-han-1-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-quiet-han-1-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-han-1-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-1-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-1-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-1-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--quiet em, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--quiet em, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--quiet em {
                font-size: var(--spectrum-display-quiet-han-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-quiet-han-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-han-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-1-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-1-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-1-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--quiet strong, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--quiet strong, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--quiet strong {
                font-size: var(--spectrum-display-quiet-han-1-strong-text-size, var(--spectrum-global-dimension-font-size-1000));
  font-weight: var(--spectrum-display-quiet-han-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-han-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-1-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-1-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(ja) .spectrum-Heading--display,
.spectrum:lang(ko) .spectrum-Heading--display,
.spectrum:lang(zh) .spectrum-Heading--display {
            font-size: var(--spectrum-display-quiet-han-2-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-quiet-han-2-text-font-weight, 300);
  line-height: var(--spectrum-display-quiet-han-2-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-2-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-2-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-2-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;
          }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--quiet em,
.spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--quiet em,
.spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--quiet em,
.spectrum:lang(ja) .spectrum-Heading--display em,
.spectrum:lang(ko) .spectrum-Heading--display em,
.spectrum:lang(zh) .spectrum-Heading--display em {
                font-size: var(--spectrum-display-quiet-han-2-emphasis-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-quiet-han-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-display-quiet-han-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-2-emphasis-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-2-emphasis-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-2-emphasis-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--quiet strong,
.spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--quiet strong,
.spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--quiet strong,
.spectrum:lang(ja) .spectrum-Heading--display strong,
.spectrum:lang(ko) .spectrum-Heading--display strong,
.spectrum:lang(zh) .spectrum-Heading--display strong {
                font-size: var(--spectrum-display-quiet-han-2-strong-text-size, var(--spectrum-global-dimension-font-size-900));
  font-weight: var(--spectrum-display-quiet-han-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-display-quiet-han-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-display-quiet-han-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-display-quiet-han-2-strong-text-letter-spacing, 0.05em);
  text-transform: var(--spectrum-display-quiet-han-2-strong-text-transform, none);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code1 {
            font-size: var(--spectrum-body-code-1-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-code-1-text-font-weight, 400);
  line-height: var(--spectrum-body-code-1-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-1-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-1-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--spectrum-body-code-1-text-font-family, 'Source Code Pro', Monaco, monospace);
          }
.spectrum-Code1 em {
                font-size: var(--spectrum-body-code-1-emphasis-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-code-1-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-code-1-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-1-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-code-1-emphasis-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code1 strong {
                font-size: var(--spectrum-body-code-1-strong-text-size, var(--spectrum-global-dimension-font-size-400));
  font-weight: var(--spectrum-body-code-1-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-code-1-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-1-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-1-strong-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code2 {
            font-size: var(--spectrum-body-code-2-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-code-2-text-font-weight, 400);
  line-height: var(--spectrum-body-code-2-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-2-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-2-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--spectrum-body-code-2-text-font-family, 'Source Code Pro', Monaco, monospace);
          }
.spectrum-Code2 em {
                font-size: var(--spectrum-body-code-2-emphasis-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-code-2-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-code-2-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-2-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-code-2-emphasis-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code2 strong {
                font-size: var(--spectrum-body-code-2-strong-text-size, var(--spectrum-global-dimension-size-225));
  font-weight: var(--spectrum-body-code-2-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-code-2-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-2-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-2-strong-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code3 {
            font-size: var(--spectrum-body-code-3-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-code-3-text-font-weight, 400);
  line-height: var(--spectrum-body-code-3-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-3-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-3-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--spectrum-body-code-3-text-font-family, 'Source Code Pro', Monaco, monospace);
          }
.spectrum-Code3 em {
                font-size: var(--spectrum-body-code-3-emphasis-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-code-3-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-code-3-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-3-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-code-3-emphasis-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code3 strong {
                font-size: var(--spectrum-body-code-3-strong-text-size, var(--spectrum-global-dimension-font-size-200));
  font-weight: var(--spectrum-body-code-3-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-code-3-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-3-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-3-strong-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code4 {
            font-size: var(--spectrum-body-code-4-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-code-4-text-font-weight, 400);
  line-height: var(--spectrum-body-code-4-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-4-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-4-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--spectrum-body-code-4-text-font-family, 'Source Code Pro', Monaco, monospace);
          }
.spectrum-Code4 em {
                font-size: var(--spectrum-body-code-4-emphasis-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-code-4-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-code-4-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-4-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-code-4-emphasis-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code4 strong {
                font-size: var(--spectrum-body-code-4-strong-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-code-4-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-code-4-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-4-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-4-strong-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code5 {
            font-size: var(--spectrum-body-code-5-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-code-5-text-font-weight, 400);
  line-height: var(--spectrum-body-code-5-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-5-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-5-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;
  font-family: var(--spectrum-body-code-5-text-font-family, 'Source Code Pro', Monaco, monospace);
          }
.spectrum-Code5 em {
                font-size: var(--spectrum-body-code-5-emphasis-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-code-5-emphasis-text-font-weight, 400);
  line-height: var(--spectrum-body-code-5-emphasis-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-5-emphasis-text-font-style, italic);
  letter-spacing: var(--spectrum-body-code-5-emphasis-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
.spectrum-Code5 strong {
                font-size: var(--spectrum-body-code-5-strong-text-size, var(--spectrum-global-dimension-size-150));
  font-weight: var(--spectrum-body-code-5-strong-text-font-weight, 700);
  line-height: var(--spectrum-body-code-5-strong-text-line-height, 1.5);
  font-style: var(--spectrum-body-code-5-strong-text-font-style, normal);
  letter-spacing: var(--spectrum-body-code-5-strong-text-letter-spacing, 0);
  margin-top: 0;
  margin-bottom: 0;

            }
/* topdoc
{{ typography/typography-default.yml }}
*/
/* topdoc
{{ typography/typography-deprecated.yml }}
*/
/* topdoc
{{ typography/typography-article.yml }}
*/
/* topdoc
{{ typography/typography-han.yml }}
*/
/* topdoc
{{ typography/typography-heading.yml }}
*/
/* topdoc
{{ typography/typography-heading-quiet.yml }}
*/
/* topdoc
{{ typography/typography-heading-strong.yml }}
*/
/* topdoc
{{ typography/typography-display.yml }}
*/
/* topdoc
{{ typography/typography-display-quiet.yml }}
*/
/* topdoc
{{ typography/typography-display-strong.yml }}
*/
/* topdoc
{{ typography/typography-body.yml }}
*/
/* topdoc
{{ typography/typography-code.yml }}
*/
/*
  The &.spectrum makes it so users can do <div class="spectrum spectrum--large"> and still get the right font sizes
  Without this, they would have to do <div class="spectrum--large"><div class="spectrum">, which makes no sense
*/
&.spectrum,
&.spectrum-Body,
.spectrum,
.spectrum-Body {
  font-size: var(--spectrum-body-4-text-size, var(--spectrum-global-dimension-font-size-100));
  font-weight: var(--spectrum-body-4-text-font-weight, 400);
  line-height: var(--spectrum-body-4-text-line-height, 1.5);
  font-style: var(--spectrum-body-4-text-font-style, normal);
}
.spectrum-Body--italic {
  font-style: var(--spectrum-body-4-emphasis-text-font-style, italic);
}
.spectrum-Body1 {
            color: var(--spectrum-body-1-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Body2,
.spectrum-Body--large {
            color: var(--spectrum-body-2-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Body3 {
            color: var(--spectrum-body-3-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Body4,
.spectrum-Body--secondary {
            color: var(--spectrum-body-4-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Body5,
.spectrum-Body--small {
            color: var(--spectrum-body-5-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Heading1 {
            color: var(--spectrum-heading-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2 {
            color: var(--spectrum-heading-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading3 {
            color: var(--spectrum-heading-3-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading4,
.spectrum-Heading--subtitle1 {
            color: var(--spectrum-heading-4-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading5 {
            color: var(--spectrum-heading-5-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading6,
.spectrum-Heading--subtitle2 {
            color: var(--spectrum-heading-6-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Subheading,
.spectrum-Heading--subtitle3 {
            color: var(--spectrum-subheading-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Detail {
            color: var(--spectrum-detail-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Heading1--quiet {
            color: var(--spectrum-heading-quiet-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2--quiet,
.spectrum-Heading--pageTitle {
            color: var(--spectrum-heading-quiet-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading1--strong {
            color: var(--spectrum-heading-strong-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2--strong {
            color: var(--spectrum-heading-strong-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading1--display {
            color: var(--spectrum-display-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2--display {
            color: var(--spectrum-display-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading1--display.spectrum-Heading1--strong {
            color: var(--spectrum-display-strong-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2--display.spectrum-Heading2--strong {
            color: var(--spectrum-display-strong-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading1--display.spectrum-Heading1--quiet {
            color: var(--spectrum-display-quiet-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum-Heading--display {
            color: var(--spectrum-display-quiet-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Body1 {
            color: var(--spectrum-body-article-1-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Body2,
.spectrum-Article .spectrum-Body--large {
            color: var(--spectrum-body-article-2-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Body3 {
            color: var(--spectrum-body-article-3-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Body4,
.spectrum-Article .spectrum-Body--secondary {
            color: var(--spectrum-body-article-4-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Body5,
.spectrum-Article .spectrum-Body--small {
            color: var(--spectrum-body-article-5-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Heading1 {
            color: var(--spectrum-heading-article-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading2 {
            color: var(--spectrum-heading-article-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading3 {
            color: var(--spectrum-heading-article-3-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading4,
.spectrum-Article .spectrum-Heading--subtitle1 {
            color: var(--spectrum-heading-article-4-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading5 {
            color: var(--spectrum-heading-article-5-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading6,
.spectrum-Article .spectrum-Heading--subtitle2 {
            color: var(--spectrum-heading-article-6-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Subheading,
.spectrum-Article .spectrum-Heading--subtitle3 {
            color: var(--spectrum-subheading-article-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Detail {
            color: var(--spectrum-detail-article-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Article .spectrum-Heading1--quiet {
            color: var(--spectrum-heading-quiet-article-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading2--quiet,
.spectrum-Article .spectrum-Heading--pageTitle {
            color: var(--spectrum-heading-quiet-article-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading1--display {
            color: var(--spectrum-display-article-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading2--display {
            color: var(--spectrum-display-article-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading1--display.spectrum-Heading1--quiet {
            color: var(--spectrum-display-quiet-article-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Article .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum-Article .spectrum-Heading--display {
            color: var(--spectrum-display-quiet-article-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Body1, .spectrum:lang(ko) .spectrum-Body1, .spectrum:lang(zh) .spectrum-Body1 {
            color: var(--spectrum-body-han-1-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Body2,
.spectrum:lang(ko) .spectrum-Body2,
.spectrum:lang(zh) .spectrum-Body2,
.spectrum:lang(ja) .spectrum-Body--large,
.spectrum:lang(ko) .spectrum-Body--large,
.spectrum:lang(zh) .spectrum-Body--large {
            color: var(--spectrum-body-han-2-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Body3, .spectrum:lang(ko) .spectrum-Body3, .spectrum:lang(zh) .spectrum-Body3 {
            color: var(--spectrum-body-han-3-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Body4,
.spectrum:lang(ko) .spectrum-Body4,
.spectrum:lang(zh) .spectrum-Body4,
.spectrum:lang(ja) .spectrum-Body--secondary,
.spectrum:lang(ko) .spectrum-Body--secondary,
.spectrum:lang(zh) .spectrum-Body--secondary {
            color: var(--spectrum-body-han-4-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Body5,
.spectrum:lang(ko) .spectrum-Body5,
.spectrum:lang(zh) .spectrum-Body5,
.spectrum:lang(ja) .spectrum-Body--small,
.spectrum:lang(ko) .spectrum-Body--small,
.spectrum:lang(zh) .spectrum-Body--small {
            color: var(--spectrum-body-han-5-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Heading1, .spectrum:lang(ko) .spectrum-Heading1, .spectrum:lang(zh) .spectrum-Heading1 {
            color: var(--spectrum-heading-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2, .spectrum:lang(ko) .spectrum-Heading2, .spectrum:lang(zh) .spectrum-Heading2 {
            color: var(--spectrum-heading-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading3, .spectrum:lang(ko) .spectrum-Heading3, .spectrum:lang(zh) .spectrum-Heading3 {
            color: var(--spectrum-heading-han-3-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading4,
.spectrum:lang(ko) .spectrum-Heading4,
.spectrum:lang(zh) .spectrum-Heading4,
.spectrum:lang(ja) .spectrum-Heading--subtitle1,
.spectrum:lang(ko) .spectrum-Heading--subtitle1,
.spectrum:lang(zh) .spectrum-Heading--subtitle1 {
            color: var(--spectrum-heading-han-4-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading5, .spectrum:lang(ko) .spectrum-Heading5, .spectrum:lang(zh) .spectrum-Heading5 {
            color: var(--spectrum-heading-han-5-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading6,
.spectrum:lang(ko) .spectrum-Heading6,
.spectrum:lang(zh) .spectrum-Heading6,
.spectrum:lang(ja) .spectrum-Heading--subtitle2,
.spectrum:lang(ko) .spectrum-Heading--subtitle2,
.spectrum:lang(zh) .spectrum-Heading--subtitle2 {
            color: var(--spectrum-heading-han-6-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Subheading,
.spectrum:lang(ko) .spectrum-Subheading,
.spectrum:lang(zh) .spectrum-Subheading,
.spectrum:lang(ja) .spectrum-Heading--subtitle3,
.spectrum:lang(ko) .spectrum-Heading--subtitle3,
.spectrum:lang(zh) .spectrum-Heading--subtitle3 {
            color: var(--spectrum-subheading-han-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Detail, .spectrum:lang(ko) .spectrum-Detail, .spectrum:lang(zh) .spectrum-Detail {
            color: var(--spectrum-detail-han-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum:lang(ja) .spectrum-Heading1--quiet, .spectrum:lang(ko) .spectrum-Heading1--quiet, .spectrum:lang(zh) .spectrum-Heading1--quiet {
            color: var(--spectrum-heading-quiet-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2--quiet,
.spectrum:lang(ko) .spectrum-Heading2--quiet,
.spectrum:lang(zh) .spectrum-Heading2--quiet,
.spectrum:lang(ja) .spectrum-Heading--pageTitle,
.spectrum:lang(ko) .spectrum-Heading--pageTitle,
.spectrum:lang(zh) .spectrum-Heading--pageTitle {
            color: var(--spectrum-heading-quiet-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading1--strong, .spectrum:lang(ko) .spectrum-Heading1--strong, .spectrum:lang(zh) .spectrum-Heading1--strong {
            color: var(--spectrum-heading-strong-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2--strong, .spectrum:lang(ko) .spectrum-Heading2--strong, .spectrum:lang(zh) .spectrum-Heading2--strong {
            color: var(--spectrum-heading-strong-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading1--display, .spectrum:lang(ko) .spectrum-Heading1--display, .spectrum:lang(zh) .spectrum-Heading1--display {
            color: var(--spectrum-display-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2--display, .spectrum:lang(ko) .spectrum-Heading2--display, .spectrum:lang(zh) .spectrum-Heading2--display {
            color: var(--spectrum-display-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--strong, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--strong, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--strong {
            color: var(--spectrum-display-strong-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--strong, .spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--strong, .spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--strong {
            color: var(--spectrum-display-strong-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading1--display.spectrum-Heading1--quiet, .spectrum:lang(ko) .spectrum-Heading1--display.spectrum-Heading1--quiet, .spectrum:lang(zh) .spectrum-Heading1--display.spectrum-Heading1--quiet {
            color: var(--spectrum-display-quiet-han-1-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum:lang(ja) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(ko) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(zh) .spectrum-Heading2--display.spectrum-Heading2--quiet,
.spectrum:lang(ja) .spectrum-Heading--display,
.spectrum:lang(ko) .spectrum-Heading--display,
.spectrum:lang(zh) .spectrum-Heading--display {
            color: var(--spectrum-display-quiet-han-2-text-color, var(--spectrum-global-color-gray-900));
          }
.spectrum-Code1 {
            color: var(--spectrum-body-code-1-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Code2 {
            color: var(--spectrum-body-code-2-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Code3 {
            color: var(--spectrum-body-code-3-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Code4 {
            color: var(--spectrum-body-code-4-text-color, var(--spectrum-global-color-gray-800));
          }
.spectrum-Code5 {
            color: var(--spectrum-body-code-5-text-color, var(--spectrum-global-color-gray-800));
          }
&,
.spectrum-Body {
  color: var(--spectrum-body-text-color, var(--spectrum-global-color-gray-800));
}
.spectrum-Body--large {
  color: var(--spectrum-body-large-text-color, var(--spectrum-global-color-gray-800));
}
.spectrum-Body--small {
  color: var(--spectrum-body-small-text-color, var(--spectrum-global-color-gray-800));
}
.spectrum-Body--secondary {
  color: var(--spectrum-body-secondary-text-color, var(--spectrum-global-color-gray-700));
}
.spectrum-Heading--display {
  color: var(--spectrum-heading-display-text-color, var(--spectrum-global-color-gray-900));
}
.spectrum-Heading--pageTitle {
  color: var(--spectrum-heading-page-title-text-color, var(--spectrum-global-color-gray-700));
}
.spectrum-Heading--subtitle1 {
  color: var(--spectrum-heading-subtitle1-text-color, var(--spectrum-global-color-gray-900));
}
.spectrum-Heading--subtitle2 {
  color: var(--spectrum-heading-subtitle2-text-color, var(--spectrum-global-color-gray-900));
}
.spectrum-Heading--subtitle3 {
  color: var(--spectrum-heading-subtitle3-text-color, var(--spectrum-global-color-gray-700));
}
